import { Injectable, ChangeDetectorRef, QueryList, EventEmitter, ElementRef, OnInit, ViewContainerRef, Attribute, Renderer2 } from '@angular/core';
import { UntypedFormBuilder ,UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
//import { columnsDef } from '../dynamic-forms/dynamic-forms.component';
import { Observable, Subscription,Observer, BehaviorSubject, throwError, of, observable } from 'rxjs';
import { HTTPService } from './http.service';
import { DatatableComponent, ColumnMode, TableColumn, DataTableColumnDirective  } from '@swimlane/ngx-datatable';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogService } from './dialog.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { DateOnlyPipe } from './DateOnlyPipe';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { SnackbarService } from './snackbar.service';
import { columnsDef } from '../interfaces/columnsDef';
import { FormServices } from './form.services';
import { UserAuthenticationServices } from './user-authentication.services';
import { MaskEditField } from '../interfaces/user-authentication';
import { CustomActionParametersComponent } from '../forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { StringUtils } from '../system-utils/utils/StringUtils';


export interface dataValue{
  entityName:string;
  fields:{[k: string]: any};
  child?:dataValue[];
}

export interface tipoSelect {
  view: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})


export class DynamicFormsService implements OnInit{
  
  public dynaColumns:TableColumn[] = [];
  public displayedColumns:columnsDef[] = [];
  public enabledColumns:columnsDef[] = [];
  public availableColumns:columnsDef[] = [];
  public cd: ChangeDetectorRef;
  public gridMode:Boolean;
  public addingNewRow:Boolean;
  public editingRow:Boolean = false;
  public removingRow:Boolean;
  public enableSave:Boolean;
  public emptyRowTemplate = {};
  public dynamicForm:UntypedFormGroup = null;
  public userConfig:Object = null;
  public loadingIndicator:boolean;
  public rows:Object[] = [];
  public temp:Object[] = [];
  public tabs:String[] = [];
  public selectedRow:columnsDef[] = [];
  public dynamicTable: DatatableComponent;
  public el:ElementRef;
  public pageLimit = 20;
  public headerHeight = 50;
  public rowHeight = 50;
  public userId:number;
  public entityName:String;
  public gridBound:String;
  public editingRowObject: columnsDef;
  public faceToolTip:String="";
  public filterExpression:String = "";
  public i:number=0;
  public fb:UntypedFormBuilder;
  public http:HTTPService;
  public snackBar:MatSnackBar;
  public dialogService:DialogService;
  public childFilterExpression:string = "";
  public ischild:boolean=false;
  public fatherData:object;
  public totalLines:number;

  private checkGridMode: BehaviorSubject<Boolean> =  new BehaviorSubject(true); // eventListene

  constructor( private _fb: UntypedFormBuilder, private _http:HTTPService, private _snackBar: MatSnackBar, private _dialogService:DialogService, private localSnackBar:SnackbarService,
    private fr:FormServices, private uid:UserAuthenticationServices,
    private dialogServices:DialogService) { 
    this.fb = _fb;
    this.http = _http;
    this.snackBar = _snackBar;
    this.dialogService = _dialogService;
    
    this.dynamicForm = this.fb.group({});
  
    this.checkGridMode.subscribe(value=>{
          if ( value ){
            this.gridBound = "ballot";
            this.faceToolTip = "Modo Formulário";
            setTimeout(()=>{
              this.rows = [...this.rows];
              this.temp  = [...this.rows];
            },0);
          }else{ 
            this.gridBound = "grid_on";
            this.faceToolTip = "Modo Grade";
          }
      });
  }


  getFrom(row:Object, entityName:string, paramObject:Object, currentRow:Object){
    
    return new Promise((resolve,reject)=>{
      let arrayData:Object[] = [];
      let codeCompany = 0;
      let codeMktp = 0;
      let codeContract = 0;
  
      if ( entityName == null){
        return;
      }

      if ( paramObject !=null){
        Object.keys(paramObject).forEach(control=>{
          const abstractControl = paramObject[control];
          
          if ( control.toUpperCase() == "CODECOMPANY"){
              codeCompany = Number(abstractControl);
          }
          
          if ( control.toUpperCase() == "CODEMKTP"){
            codeMktp = Number(abstractControl);
          }
  
          if ( control.toUpperCase() == "CODECONTRACT"){
            codeContract = Number(abstractControl);
          }
  
          if ( abstractControl != null){
            arrayData.push({
              'key':'@'+control,
              'value':abstractControl
            })
          }
        })
      }

      if ( currentRow != null ){
        Object.keys(currentRow).forEach(linha=>{
  
          if ( linha.toUpperCase() == "CODECOMPANY"){
            codeCompany = Number(currentRow['CODECOMPANY']);
          }
          
          if ( linha.toUpperCase() == "CODEMKTP"){
            codeMktp = Number(currentRow['CODEMKTP']);
          }
    
          if ( linha.toUpperCase() == "CODECONTRACT"){
            codeContract = Number(currentRow['CODECONTRACT']);
          }
          
          if ( ObjectUtil.isNotEmpty(currentRow[linha])){
            arrayData.push({
              'key':'@'+linha,
              'value':currentRow[linha]
            })
          }
        });
      }

      if ( row != null ){
        Object.keys(row).forEach(linha=>{
  
          if ( linha.toUpperCase() == "CODECOMPANY"){
            codeCompany = Number(row['CODECOMPANY']);
          }
          
          if ( linha.toUpperCase() == "CODEMKTP"){
            codeMktp = Number(row['CODEMKTP']);
          }
    
          if ( linha.toUpperCase() == "CODECONTRACT"){
            codeContract = Number(row['CODECONTRACT']);
          }
          
          if ( ObjectUtil.isNotEmpty(row[linha])){
            arrayData.push({
              'key':'@'+linha,
              'value':row[linha]
            })
          }
          
        });
    
      }
      
      let ob = {
        'expressao':'{@get'+entityName.toUpperCase()+"}",
        'novo':true,
        'values':arrayData
      }
      
      ob['codecompany'] = codeCompany;
      ob['codemktp'] = codeMktp;
      ob['codecontract'] = codeContract == null || codeContract == 0 ? this.uid.user.companylist[0].codecontract: codeContract;
  
      this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
          
        let resultado = data['resultado'];
        let value:string | string[]  = null;
        if ( !ObjectUtil.isNotEmpty(resultado)){
            return;
        }
        
        let objeto;
        try{
          objeto = JSON.parse(resultado);
        }catch(error)  {
          return;
        }
  
        let SQL:Object[] = null;
        try{
          SQL = JSON.parse(JSON.stringify(objeto['SQL']));
        }catch(error){
          return;
        }
        
        let ehArray:boolean = false;
        
        if ( SQL == null ){
          return;
        }

        if ( SQL.length == 0 ){
          return;
        }
        this.dialogService.title = "Importação de Dados";
        this.dialogService.openNewDialog(`Serão importadas ${SQL.length} linhas. Deseja continuar?`,async ()=>{
          for (var data of SQL ){
  
              let dataSend:object = {};
  
              Object.keys(data).forEach(key=>{
                try{
                  dataSend[key.toUpperCase()] = data[key]
                }catch(error){
                }
              });
  
              
              dataSend["entityName"] = entityName;
  
              await new Promise((resolve,reject)=>{
                this.http.post(dataSend,"JsonBrokerServices/save",false,true,true).subscribe(x=>{
                  this.localSnackBar.showSuccess('Processo Importado com Sucesso.');
                  resolve("ok")
                },error=>{
                  throw error;
                  //reject(error);
                });
              });
          }
          //resolve("ok");
        });
      });
      
    });
    
  }

  getFromPrompt(row:Object, entityName:string, complex:boolean, query:string, param:string, currentRow:Object):Promise<any>{
    
    return  new Promise((resolve,reject)=>{
      if ( param != null){
    
        this.dialogServices.openGenericDialog(CustomActionParametersComponent,{data:query, param:param, newMode:true, entityName:entityName}, async (data)=>{

              if ( complex ){
                var p = await this.getFromComplex(row, entityName, JSON.parse(data),currentRow);       
                resolve('ok')
                return p;
              }else{
                var p = await this.getFrom(row, entityName, JSON.parse(data),currentRow);       
                resolve('ok');
                return p;
              }
        },()=>{
        })
      }else{

        if ( complex ){
          return this.getFromComplex(row, entityName,  null, currentRow).then(data=>{
            resolve('ok');
          });      
        }else{
          return this.getFrom(row, entityName,  null, currentRow).then(data=>{
            resolve('ok');
          });
        }
      }

    });
    

  }

  getFromComplex(row:Object, entityName:string, paramObject:Object, currentRow:Object){
    
    return  new Promise((resolve,reject)=>{
      let arrayData:Object[] = [];
      let codeCompany = 0;
      let codeMktp = 0;
      let codeContract = 0;
  
      if ( entityName == null){
        return;
      }

      if ( paramObject !=null){
        Object.keys(paramObject).forEach(control=>{
          const abstractControl = paramObject[control];
          
          if ( control.toUpperCase() == "CODECOMPANY"){
              codeCompany = Number(abstractControl);
          }
          
          if ( control.toUpperCase() == "CODEMKTP"){
            codeMktp = Number(abstractControl);
          }
  
          if ( control.toUpperCase() == "CODECONTRACT"){
            codeContract = Number(abstractControl);
          }
  
          if ( abstractControl != null){
            arrayData.push({
              'key':'@'+control,
              'value':abstractControl
            })
          }
        })
      }

      if ( currentRow!= null ){
        Object.keys(currentRow).forEach(linha=>{
  
          if ( linha.toUpperCase() == "CODECOMPANY"){
            codeCompany = Number(currentRow['CODECOMPANY']);
          }
          
          if ( linha.toUpperCase() == "CODEMKTP"){
            codeMktp = Number(currentRow['CODEMKTP']);
          }
    
          if ( linha.toUpperCase() == "CODECONTRACT"){
            codeContract = Number(currentRow['CODECONTRACT']);
          }
          
          if ( ObjectUtil.isNotEmpty(currentRow[linha])){
            arrayData.push({
              'key':'@'+linha,
              'value':currentRow[linha]
            });
          }
        });
      }
  

      if ( row!= null ){
        Object.keys(row).forEach(linha=>{
  
          if ( linha.toUpperCase() == "CODECOMPANY"){
            codeCompany = Number(row['CODECOMPANY']);
          }
          
          if ( linha.toUpperCase() == "CODEMKTP"){
            codeMktp = Number(row['CODEMKTP']);
          }
    
          if ( linha.toUpperCase() == "CODECONTRACT"){
            codeContract = Number(row['CODECONTRACT']);
          }
          
          if ( ObjectUtil.isNotEmpty(row[linha])){
            arrayData.push({
              'key':'@'+linha,
              'value':row[linha]
            })
          }
          
        });
      }
  
      let ob = {
        'expressao':'{@get'+entityName.toUpperCase()+"}",
        'novo':true,
        'values':arrayData
      }
  
      ob['codecompany'] = codeCompany;
      ob['codemktp'] = codeMktp;
      ob['codecontract'] = codeContract == null || codeContract == 0 ? this.uid.user.companylist[0].codecontract: codeContract;
  
      this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
        let resultado = data['resultado'];
        let value:string | string[]  = null;
        if ( !ObjectUtil.isNotEmpty(resultado)){
            return;
        }
        
        let objeto;
        try{
          objeto = JSON.parse(resultado);
        }catch(error)  {
          return;
        }
  
        let SQL:Object[] = null;
        let ehArray:boolean = false;
        try{
          SQL = JSON.parse(JSON.stringify(objeto['SQL']));
          ehArray = true;
        }catch(Exception){
          ehArray = false;
        }

        
        if ( SQL == null ){
          return;
        }

        if ( SQL.length == 0 ){
          return;
        }
        this.dialogService.title = "Importação de Dados";
        this.dialogService.openNewDialog(`Serão importadas ${SQL.length} linhas. Deseja continuar?`,async ()=>{
  
          let dataSend  = this.mountComplexSave(SQL)
          await new Promise((resolve1,reject)=>{
            this.http.post(dataSend,"JsonBrokerServices/saveEntities",false,true,true).subscribe(x=>{
              this.localSnackBar.showSuccess('Processo Importado com Sucesso.');
              resolve1("ok1");
              resolve('ok2');
            },error=>{
              throw error;
              //reject(error);
            });
          });
      
          
        });
      });
      
    });
    
  }
  mountComplexSave(SQL: Object[]) {
    
    // let dataSend = [];
    // let entities:dataValue[] = [];
    // let principalEntity:dataValue;

    // for (var line of SQL ){
      
    //   Object.keys(line).forEach(key=>{
    //     let entity = key.split("_",2)[0];
    //     let fieldName:string = key.split('_').slice(1).join('_');
  
    //     if ( entities.findIndex(d=>d.entityName.toUpperCase()==entity.toUpperCase()) == -1 && principalEntity == null){
    //          principalEntity = {
    //                 entityName: StringUtils.toDisCamelCase(entity),
    //                 fields:{}
    //         }
    //         principalEntity.fields[fieldName] = line[key];
    //     }else{
    //         if ( principalEntity!= null  && principalEntity.entityName.toUpperCase() == entity.toUpperCase() ){
    //           principalEntity.fields[fieldName] = line[key];
              
              
    //         }else{
    //             if (  principalEntity.entityName.toUpperCase() != entity.toUpperCase() ){
    //                 if ( principalEntity.child ){
                        
    //                    let d:dataValue = principalEntity.child.find(c=>c.entityName.toUpperCase()==entity.toUpperCase());
                       
    //                    if ( d!=null  ){
    //                        d.fields[fieldName] = line[key];
    //                    }else{
    //                        let newValue:dataValue = {
    //                            entityName:StringUtils.toDisCamelCase(entity),
    //                            fields:{}
    //                        }
    //                        newValue.fields[fieldName] = line[key];
    //                        principalEntity.child.push(newValue);
    //                    }
    //                 }else{
    //                      let newValue:dataValue = {
    //                            entityName:StringUtils.toDisCamelCase(entity),
    //                            fields:{}
    //                        }
    //                     newValue.fields[fieldName] = line[key];
    //                     principalEntity.child = [newValue];
                        
    //                 }
    //             }
    //         }
    //     }
          
    //   });
    //   dataSend.push(principalEntity)  
    // }

    let dd = [];

    for (var line of SQL ){
    
      let lineEntity:dataValue[] = [];
      
      Object.keys(line).forEach(key=>{
        let entity = StringUtils.toDisCamelCase(key.split("_",2)[0]);
        let fieldName:string = key.split('_').slice(1).join('_');
        
        let d:dataValue = lineEntity.find(c=>StringUtils.toDisCamelCase(c.entityName)==StringUtils.toDisCamelCase(entity));
        
        if ( d == null ){
           let newValue:dataValue = {
               entityName:StringUtils.toDisCamelCase(entity),
               fields:{}
           }
           newValue.fields[fieldName] = line[key];
           lineEntity.push(newValue);
        }else{
            d.fields[fieldName]=line[key]
        }
      });
      dd.push(lineEntity)
    }
    
    let newData:dataValue[] = [];
    let firstEntity = null;
    
    for ( let line of dd ){
        
        let iMain = -1;
        for ( var f of line ){
            let i = -1;
            if ( newData.length == 0){
                firstEntity = StringUtils.toDisCamelCase(f.entityName);
                newData.push(f);
            }else{
                if ( f.entityName == firstEntity ){
                    iMain = newData.findIndex(d=>StringUtils.toDisCamelCase(firstEntity) == StringUtils.toDisCamelCase(d.entityName) && JSON.stringify(f.fields) === JSON.stringify(d.fields));        
                    if (iMain == -1 ){
                       newData.push(f); 
                    }
                }
            }
            
            if ( StringUtils.toDisCamelCase(f.entityName) != StringUtils.toDisCamelCase(firstEntity) ){
                //get parent // 
                let dataFields:dataValue = line.find(d=>StringUtils.toDisCamelCase(d.entityName) == StringUtils.toDisCamelCase(firstEntity)).fields;
                
                let iMain = newData.findIndex(d=>firstEntity == d.entityName && JSON.stringify(dataFields) === JSON.stringify(d.fields));        
                
                //get child
                if ( newData[iMain].child == null ){
                  newData[iMain].child = [f];
                }else{
                  let i = newData[iMain].child.findIndex(d=>StringUtils.toDisCamelCase(f.entityName) == StringUtils.toDisCamelCase(d.entityName) && JSON.stringify(f.fields) === JSON.stringify(d.fields));        
                  if ( i == -1 ){
                      if (newData[iMain].child ){
                          newData[iMain].child.push(f);
                      }else{
                          newData[iMain].child = [f];
                      }
                  }
                }
            }
            
                
        }    
    }
    
    let d = {
      data: newData
    }
    
    return d;
    
  }

  getDataFromTable(group:UntypedFormGroup|object, columnName:string, entityName:string, mainGroup?:UntypedFormGroup, alternateName:string = '', typeField:string = 'text'){
      
      let arrayData:Object[] = [];

      let codeCompany = 0;
      let codeMktp = 0;
      let codeContract = 0;

      if ( entityName == null){
        return;
      }

      if ( group instanceof UntypedFormGroup ){
        Object.keys(group.controls).forEach(control=>{
          const abstractControl = group.controls[control];
          
          if ( control.toUpperCase() == "CODECOMPANY"){
              codeCompany = abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          }
          
          if ( control.toUpperCase() == "CODEMKTP"){
            codeMktp = abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          }
  
          if ( control.toUpperCase() == "CODECONTRACT"){
            codeContract = abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          }
  
          if ( abstractControl.value != null){
            arrayData.push({
              'key':'@'+control,
              'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
            })
          }
        })
      }else{
        Object.keys(group).forEach(control=>{
          arrayData.push({
            'key':'@'+control,
            'value':group[control]
          })
        });
      }
      
      if ( mainGroup != null ){
        Object.keys(mainGroup.controls).forEach(control=>{
          const abstractControl = mainGroup.controls[control];
          
          if ( control.toUpperCase() == "CODECOMPANY"){
              codeCompany = abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          }
          
          if ( control.toUpperCase() == "CODEMKTP"){
            codeMktp = abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          }
  
          if ( control.toUpperCase() == "CODECONTRACT"){
            codeContract = abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          }
  
          if ( abstractControl.value != null){
            arrayData.push({
              'key':'@'+control,
              'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
            })
          }
        })
      }

        let ob = {
          'expressao':'{@get'+entityName.toUpperCase()+"."+columnName.toUpperCase()+"}",
          'novo':true,
          'values':arrayData
        }

        if (alternateName!= null && alternateName != '' ){
          ob['expressao']='{@get'+alternateName.toUpperCase()+'}';
        }

        ob['codecompany'] = codeCompany
        ob['codemktp'] = codeMktp
        ob['codecontract'] = codeContract
  
        this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(data=>{
        
          let resultado = data['resultado'];
          let value:string | string[]  = null;
          if ( !ObjectUtil.isNotEmpty(resultado)){
              return;
          }

          
          let objeto;
          try{
            objeto = JSON.parse(resultado);
          }catch(error)  {
            return;
          }

          let SQL:Object[] = objeto['SQL'];
          let ehArray:boolean = false;
          
          if ( SQL != null && SQL.length > 0 ){
            if ( SQL.length == 1){
              value = SQL[0]['VALOR'];
            }else{
              
              (value as string[]) = [];
              SQL.forEach(data=>{
                  (value as string[]).push(data['VALOR']);
              })
            } 
          }else{
              value = resultado.toString();
          }

          if ( typeField ) {
              if ( typeField == 'number'){
                if ( value != null ){
                  value = value.toString().replace(/\./g,',');
                }
              }
          }
          
          if ( value != null ){
              if ( !ehArray){
                  if ( group instanceof UntypedFormGroup ){
                    group.get(columnName).setValue(value);
                  }else{
                    group[columnName] = value;
                  }
                  
                
              }else{
                  let settingValue ='';
                  (value as string[]).forEach(data=>{
                    settingValue = settingValue + data + ';'
                  });

                  if ( group instanceof UntypedFormGroup ){
                    group.get(columnName).setValue(settingValue);
                  }
                  
              }
          }
          

        },error=>{
          throw error;
        },()=>{
        });
  }


  ngOnInit(): void {
    
  }


  hasError(controle:string, group:UntypedFormGroup){
    if ( group.get(controle).invalid ){
      return true;
    }else{
      return false;
    }

  }

  getError(controle:string, group:UntypedFormGroup){

  }

  public saveUserCfg(jsonDec:Object):void{

    this.loadingIndicator  = true;
    this.http.post(jsonDec,"JsonBrokerServices/find",false).subscribe(
      data =>{
        let idInstance:number = data["Mktpdic"][0]["IDINSTANCE"];

        let jsonSave:Object = {
          "entityName":"Mktpusercfg",
          "IDUSER": this.userId,
          "IDINSTANCE":idInstance,
          "CONFIG": this.userConfig["CONFIG"],
          "FILTER":this.userConfig["FILTER"]
    
        }
        
        this.http.post(jsonSave,"JsonBrokerServices/save",true).subscribe(
          data => {
            this.mountDataGrid();
          },
          error=>{
          },
          ()=>{
            this.loadingIndicator = false;
            this.cd.markForCheck();
          }
        );
      },
      error=>{
      },
      ()=> {
        
      }
    );

  }
   
  public doRefreshColumns():void{
       this.availableColumns = this.displayedColumns.filter(x =>{
       let valor = true;
       this.enabledColumns.forEach(y =>{
           if ( y.COLUMNNAME == x.COLUMNNAME  ) {
             valor = false;
             
           }
        });
        
        return valor;
    });
    this.cd.markForCheck();
   // 
    //this.rows = [...this.rows];
  }

  public startAddRow(duplicate:boolean):void{
    this.addingNewRow = true;
    this.gridMode = false;
    this.checkGridMode.next(false);
    this.editingRow = true;
    
    
   

    if ( !duplicate ){
      this.enabledColumns.forEach(x => {
        this.emptyRowTemplate[x.COLUMNNAME] = null;
        this.clearValue(x.COLUMNNAME);  
      });
      this.dynamicForm.reset();
    }else{
      this.enabledColumns.forEach(x => {
        if ( x.ISPK == 1){
          this.emptyRowTemplate[x.COLUMNNAME] = null;
          this.clearValue(x.COLUMNNAME);  
        }
      });
      this.editingEventHandle(null);
    }

    

    if ( this.ischild ){
       if ( ObjectUtil.isNotEmpty(this.fatherData)){
         Object.keys(this.fatherData).forEach(key=>{
            this.dynamicForm.get(key).setValue(this.fatherData[key]);
         })
       }
    }

    
    

  }

  
  public refreshForm(enableColumnsPriv:columnsDef,row:Object = null, canceling:Boolean = false):void{
    let rowFormTemplate:Object = {};
    
    if ( enableColumnsPriv != null ){
        this.dynamicForm.addControl(enableColumnsPriv.COLUMNNAME,new UntypedFormControl(''));
    }else{
      this.displayedColumns.forEach(x=> {

        let temRef:string = Object.keys(x).find((k:string,index:number)=>{  
          if ( k.startsWith("MKTPDICREF")){
            return true;
          }
        });

        let required:boolean =  x.ISREQUIRED == 1 || x.ISNULLABLE == 0 ? true : false;
        let size:number = x.COLSIZE;

        //this.dynamicForm.addControl(x.COLUMNNAME,new FormControl({value:'',disabled:x.ISIDENTITY==1 || x.ISPK == 1/*|| x.COLUMNNAME.startsWith("FK_") || temRef != null*/ }));  
        this.dynamicForm.addControl(x.COLUMNNAME,new UntypedFormControl(
              {
                value:'',
                disabled:x.ISIDENTITY==1 || (x.ISPK == 1 && x.ISFK != 1) || x.INCREMENTALFIELD == 1 || x.ISREADONLY == 1,
              })
              );

              let arrayValidors = [];
              if ( required ){
                  arrayValidors.push(Validators.required);
              }
  
              if ( x.DATATYPE == "VARCHAR" || x.DATATYPE == "CHAR"){
                  if ( size > 0 ){
                      arrayValidors.push(Validators.maxLength(size));
                  }
              }
  
              if ( arrayValidors.length > 0 ){
                  this.dynamicForm.get(x.COLUMNNAME).setValidators(arrayValidors);
                  this.dynamicForm.get(x.COLUMNNAME).updateValueAndValidity();
              }
      });

      if ( canceling ){
        row = this.editingRowObject;
      }

      if ( !this.addingNewRow ){
        if ( row != null ){
          for(var key in this.dynamicForm.controls) {
            var ob:Object = {};
            ob[key] = row[key];
            if ( ob == undefined){
              this.dynamicForm.patchValue(null);
            }else{
              this.dynamicForm.patchValue(ob);
            }
            
          }
        }
      }
    }
    this.cd.markForCheck();
  }


  changeEventHandle(event, columnName:String, value:any, row:JSON){
    if ( columnName != null ){
      row[columnName.toString()] = value == "" ? null : value;
    }
  }


  changeFace(){

  
    if (this.selectedRow.length > 0){

      if ( this.selectedRow.length >  1){
        this.snackBar.open("Para editar deve-se selecionar apenas uma linha.",null,{duration:3000});  
      }else{
        this.gridMode = !this.gridMode;
        this.checkGridMode.next(this.gridMode);
        let index:number = this.rows.indexOf(this.selectedRow[0]);
        
         setTimeout(()=>{
          if  ( Math.floor(index/this.dynamicTable.pageSize) != this.dynamicTable.offset ){
            this.dynamicTable.bodyComponent.updateOffsetY(Math.floor(index / this.dynamicTable.pageSize));
          }
        },300);
      }

      
    }else{
      if ( !this.gridMode ){
        this.snackBar.open("Para editar é necessário escolher uma linha.",null,{duration:3000});
      }
      
    }

    
  }

  editingEventHandle(event){
    this.editingRow = true;
    this.enableSave = true;
    this.editingRowObject = this.selectedRow[0];
    
  }

  public isSelect(r:columnsDef):tipoSelect[]{

    let contentSelect:tipoSelect[] = [];
    
    if ( ObjectUtil.isNotEmpty(r.VALIDATIONERROR)){
      
      var ob:Object = JSON.parse(r.VALIDATIONERROR);
      if ( ob['type'] == "select"){
          contentSelect  = ob["options"];
      }
    }

    return contentSelect;
  }


  clearValue (columnName:String):void{
    var ob:Object = {};
    ob[columnName.toString()] = null;
    this.dynamicForm.patchValue(ob);
  }


  loadUserConfig( ):Observable<Object>{

    let ob = new Object();
    ob= {      
      "entityName":"Mktpusercfg",
      "condition":`iduser = ${this.userId} and idinstance = ( select idinstance from Mktpdic where instancename='${this.entityName}')`
    };

    let observable:Observable<Object> = this.http.post(ob,"JsonBrokerServices/find", true);
    return observable;
  }

  removeRow(){
    
    if ( this.selectedRow.length == 0 ){
      this.snackBar.open("Para excluir deve-se selecionar uma linha.",null,{duration:3000});  
      return;
    }
    
    this.loadingIndicator = true;
    this.dialogService.errorDialoag = false;
    this.dialogService.openDialog("Deseja remover esse registro?",this, (component:DynamicFormsService)=>{
      let condition:String = "0=1";
    
      if ( this.selectedRow.length > 0 ){
        component.loadingIndicator = true;
        for ( let i:number= 0; i<this.selectedRow.length; i++){
          let ob:Object = {};  
          this.displayedColumns.filter(x=>{return x.ISPK === 1}).forEach(y=>{
              ob[y.COLUMNNAME] = this.selectedRow[i][y.COLUMNNAME];
          });
          
          let remove:Object = {}; 
          condition = this.trasnformToString(ob);
          remove["entityName"] = this.entityName;
          remove["condition"] = condition;
  
            this.http.post(remove,"JsonBrokerServices/remove",false).subscribe(
              data=>{
                
                if ( !this.gridMode ){
                  this.changeFace();
                }
                this.selectedRow.splice(i,1);
                setTimeout(()=>{
                  component.loadingIndicator = false;
                  this.cd.detach();
                  this.cd.detectChanges();
                  this.cd.reattach();
                  this.fetch(0,false,false,null);
                },0);
              },
              error => { 
                this.loadingIndicator = false;
                this.cd.markForCheck();
                throw("Erro:"+JSON.parse(error._body)["message"]  );
              },
              ()=>{
                
               
              }
            
            )
        }
        
        
      }
      
    }, (component:DynamicFormsService)=>{
      component.loadingIndicator = false;
      this.cd.detach();
      this.cd.detectChanges();
      this.cd.reattach();
      
    });

  }

  fetch(limit:number, child:Boolean = false, doPageFetch?:Boolean, func?:()=>void ):void {
    
    //return new Observable<Object[]>(observable=>{
    
        this.loadingIndicator = true;

        if ( doPageFetch  == null ) {
          doPageFetch = true;
        }
          
        
        let ob = new Object();
        if ( doPageFetch ){
          let fetchSize:number = this.rows.length;//( limit + this.rows.length ) ;
          
          if ( child ){
            
            if ( this.filterExpression != "" || this.childFilterExpression != "" ){

              let expression:String  = "";

              if ( this.childFilterExpression != "" && this.filterExpression !=""){
                expression = this.childFilterExpression + " and " + this.filterExpression; 
              }else{
                expression = this.childFilterExpression + " "+ this.filterExpression; 
              }
              ob= {      
                "entityName":this.entityName.toString(),
                "rows": this.pageLimit,
                "fetchSize": fetchSize,
                "showPresentation":true,
                "showRelationshipData":false,
                "showRelationship":true, 
                "condition": expression
              }
            }else{
              ob= {      
                "entityName":this.entityName.toString(),
                "rows": this.pageLimit,
                "fetchSize": fetchSize,
                "showPresentation":true,
                "showRelationshipData":false,
                "showRelationship":true, 
                "condition":"0=1"
              }
            }

          }else{
            if ( this.filterExpression != "" || this.childFilterExpression != "" ){

              let expression:String  = "";

              if ( this.childFilterExpression != "" && this.filterExpression !=""){
                expression = this.childFilterExpression + " and " + this.filterExpression; 
              }else{
                expression = this.childFilterExpression + " "+ this.filterExpression; 
              }

              ob= {      
                "entityName":this.entityName.toString(),
                "rows": this.pageLimit,
                "fetchSize": fetchSize,
                "showPresentation":true,
                "showRelationshipData":false,
                "showRelationship":true, 
                "condition": expression
              }
            }else{
  
              ob= {      
                "entityName":this.entityName.toString(),
                "rows": this.pageLimit,
                "showPresentation":true,
                "showRelationshipData":false,
                "showRelationship":true, 
                "fetchSize": fetchSize
              }
            }
          }
          
          
        
        }else{
          if ( this.filterExpression != "" || this.childFilterExpression != ""){

            let expression:String  = "";

            if ( this.childFilterExpression != "" && this.filterExpression !=""){
              expression = this.childFilterExpression + " and " + this.filterExpression; 
            }else{
              expression = this.childFilterExpression + " "+ this.filterExpression; 
            }

            ob= {
              "entityName":this.entityName.toString(),
              "showPresentation":true,
              "showRelationshipData":false,
              "showRelationship":true, 
              "condition": expression
            }
      
          }else{
            ob= {
              "entityName":this.entityName.toString(),
              "showPresentation":true,
              "showRelationshipData":false,
              "showRelationship":true
            }
      
          }

          if ( !this.gridMode){
            this.changeFace();
          }
        }
        
        this.http.post(ob,"JsonBrokerServices/find", true).subscribe(
        data => { 
              let ti:columnsDef[] =  data['table_information']   ;
              this.displayedColumns = ti;
              this.totalLines = data['totalLines'];
          
              this.mountDataGrid();
              if ( doPageFetch ){
                let rows = [...this.rows,...data[this.entityName.toString()]];
                this.rows = rows;
                this.temp  = [...this.rows];
                this.createTabs();
                this.doRefreshColumns();
                this.settingPk(this.rows);
              }else{
                this.rows = [...data[this.entityName.toString()]];
                this.temp  = [...this.rows];
                this.doRefreshColumns();
                this.createTabs();
                this.settingPk(this.rows);
              }

              //observable.next(this.rows);
              //observable.complete();
              
          },
          error => { 
              this.loadingIndicator = false;
              this.cd.markForCheck();
              throw("Erro:"+error  );
          },
          
          ()=>{
              this.loadingIndicator = false;          
              if ( func != null){
                func.call(this);
              }
          }
        
        );

      //});   
    
  }

  public settingPk(rows):void{
    
    let pkCol:string[] = [];

    this.displayedColumns.forEach(x=>{
      if ( x.ISPK === 1){
          let columnName:string = x.COLUMNNAME;
          pkCol.push(columnName);
      }
    });

    var obKey = {};

    if ( rows instanceof Array ){
      rows.forEach((row:Object) => {
        pkCol.forEach(x =>{
          obKey[x] = row[x];
        });
        row['filterExpression'] = this.trasnformToString(obKey);
        
      });
    }else{
        pkCol.forEach(x =>{
          obKey[x] = rows[x];
        });
        rows['filterExpression'] = this.trasnformToString(obKey);
    
  }
}


  private createTabs():void{

      if (this.rows.length > 0 ){
        if ( this.rows[0].hasOwnProperty("$$REFERENCES")){
          let refName:String = this.rows[0]["$$REFERENCES"][0]["REF_TABLE_NAME"];
          if ( this.tabs.indexOf(refName) == -1 ){
              this.tabs.push(refName);
          }
        }
      }

  }

  public mountDataGrid():void{
    
    if ( this.userConfig != null && this.userConfig != undefined && Object.keys(this.userConfig).length > 0 && this.userConfig['CONFIG'] != null ) {
        
        let jsonOb:JSON = JSON.parse(this.userConfig['CONFIG'] );

        let userCfgEnableColumns:Object[] = [];
        if ( ObjectUtil.isNotEmpty(jsonOb['datagrid'])){
          if ( ( ObjectUtil.isNotEmpty(jsonOb['datagrid']['enableColumns']))){
            userCfgEnableColumns =  jsonOb['datagrid']['enableColumns'];
          }
          
        }
        
      
        userCfgEnableColumns = userCfgEnableColumns.sort((leftSide,righSide):number =>{
        if (leftSide['columnGridOrder'] > righSide['columnGridOrder']  ) return 1;
          if (leftSide['columnGridOrder'] < righSide['columnGridOrder']  ) return -1;
          return 0;
        } );

        this.dynaColumns = [];
        this.enabledColumns = [];
        if ( userCfgEnableColumns.length > 0 ){
          userCfgEnableColumns.forEach(x=> {
              let isVisible:Boolean = x["visible"];

              if ( isVisible){
                this.enabledColumns.push (this.displayedColumns.filter(
                  def=>{
                    
                    if ( def.COLUMNNAME == x["columnName"] ){
                      def.COLWIDTH =  x["columnGridSize"] ;
                      def.headerName = x["columnName"];
                      def.field = x["columnName"];
                      let refNameS:string = Object.keys(def).find((k:string)=>{ return k.startsWith("FK_")} );
                      if ( refNameS ){
                          let constraint_name:string = def[refNameS][0]["CONSTRAINT_NAME"];
                          def.refName = constraint_name;
                          //def.field = x["columnName"] +"_"+constraint_name.toString();
                      }
                      return def;
                    }
                  })[0]);
              }
        });
      }
    }else{
          var filter:JSON = null;

          if ( this.userConfig != null ){
            if ( this.userConfig.hasOwnProperty('FILTER')  ){
              filter = JSON.parse(this.userConfig['FILTER']);
            }
          }
          
          this.userConfig = {};
          
          let columnsOb:Object[]  = [];
          
          let i=1;
          this.displayedColumns.forEach(x=>{
             let ob = {
                    "columnName":x.COLUMNNAME,
                    "columnGridSize":x.COLWIDTH == null || x.COLWIDTH == 0? 150 : x.COLWIDTH,
                    "columnGridOrder":x.COLORDER == null || x.COLORDER == 0? i : x.COLORDER,
                    "visible":true
                };
              
                columnsOb.push(ob);
                i++;
          })

          this.dynaColumns = [];
          this.enabledColumns= this.displayedColumns;

          let jsonDec:Object ={
            "entityName":"Mktpdic",
            "condition":`instancename='${this.entityName}'`
          };
      

          this.http.post(jsonDec,"JsonBrokerServices/find",false).subscribe(
            data =>{
              let idInstance:number = data["Mktpdic"][0]["IDINSTANCE"];
      
              if ( filter != null ){
                this.userConfig = {
                  //"entityName":"Mktpusercfg",
                  "IDUSER": this.userId,
                  "IDINSTANCE":idInstance,
                  "CONFIG": JSON.stringify({'datagrid':{'enableColumns':columnsOb}}),
                  "FILTER": JSON.stringify(filter)
                };
              }else{
                this.userConfig = {
                  //"entityName":"Mktpusercfg",
                  "IDUSER": this.userId,
                  "IDINSTANCE":idInstance,
                  "CONFIG": JSON.stringify({'datagrid':{'enableColumns':columnsOb}}),
                  "FILTER": JSON.stringify([])
                };
              }
              
            }
          );
        }

        this.enabledColumns.forEach((c:columnsDef,index:Number,array:columnsDef[])=>{
          
          if ( c.DATATYPE == "DATETIME"){

            let column:TableColumn = {
              prop: c.COLUMNNAME,
              name: c.COLUMNDESC,
              width : c.COLWIDTH == null || c.COLWIDTH == 0 ? 150 : c.COLWIDTH,
              pipe: new DateOnlyPipe("pt"),

            }

            this.dynaColumns.push(column);
  
          }else{

            let column:TableColumn = {
              prop: c.COLUMNNAME,
              name: c.COLUMNDESC,
              width : c.COLWIDTH == null || c.COLWIDTH == 0 ? 150 : c.COLWIDTH
            }

            this.dynaColumns.push(column);

          }
          

        });

  }


  exportAsCSV() {
    const columns: TableColumn[] = this.dynamicTable.columns || this.dynamicTable._internalColumns;
    const headers =
        columns
            .map((column: TableColumn) => column.name)
            .filter((e) => e);  // remove column without name (i.e. falsy value)

    const rows: any[] = this.dynamicTable.rows.map((row) => {
        let r = {};
        columns.forEach((column) => {
            if (!column.name) { return; }   // ignore column without name
            if (column.prop) {
                let prop = column.prop;
                r[prop] = (typeof row[prop] === 'boolean') ? (row[prop]) ? 'Sim'
                                                                         : 'Não'
                                                           : row[prop];
            } else {
                // special cases handled here
            }
        })
        return r;
    });

    const options = {
        fieldSeparator  : ';',
        quoteStrings    : '"',
        decimalseparator: ',',
        showLabels      : true,
        headers         : headers,
        showTitle       : false,
        title           : 'Exportação de '+this.entityName,
        useBom          : true,
        noDownload      : false
    };

    
    return new ngxCsv(rows, 'Report_'+this.entityName, options);

}

  onScroll(offsetX:number,offsetY: number) {
    // total height of all rows in the viewport
    const viewHeight =
      this.el.nativeElement.getBoundingClientRect().height - this.headerHeight;
    
      
    if ( this.rows.length  != this.totalLines) {
        
      if ( 
        !this.loadingIndicator &&
        offsetY + viewHeight >= this.rows.length * this.rowHeight
      ) {
        // total number of results to load
        let limit = this.pageLimit;

        // check if we haven't fetched any results yet
        if (this.rows.length === 0) {
          // calculate the number of rows that fit within viewport
          const pageSize = Math.ceil(viewHeight / this.rowHeight);

          // change the limit to pageSize such that we fill the first page entirely
          // (otherwise, we won't be able to scroll past it)
          limit = Math.max(pageSize, this.pageLimit);
        }
        
        if ( offsetY == 0 ){
          this.fetch(0);
        }else{
          this.fetch(limit,false,true);
        }
        
      }
    }
  }
 
  refreshLocalData(data){

    let ob2:Object = {
      "entityName":this.entityName,
      "condition":this.trasnformToString(data),
      "showPresentation":true
    }

    this.refreshData(ob2,(data:Object)=>{
      
      this.selectedRow = [];
      this.dynamicTable.selected = [data];
      this.selectedRow[0] = data as columnsDef;
      this.dynamicTable.bodyComponent.select.emit();
    });
  }

  saveRow(){
    
    this.editingRow = false;
    this.enableSave = false;
    this.loadingIndicator = true;
    
    //let ob:Object = this.addingNewRow ? this.dynamicForm.value : this.dynamicForm.getRawValue();
    let ob:Object = this.dynamicForm.getRawValue();
    
    if ( this.dynamicForm.invalid ){
      this.editingRow = true;
      this.enableSave = true;
      this.loadingIndicator = false;
      this.dynamicForm.markAllAsTouched();
      
      return;
    }
    /*if ( this.ischild ){
      if ( ObjectUtil.isNotEmpty(this.fatherData)){
        Object.keys(this.fatherData).forEach(key=>{
           this.dynamicForm.get(key).setValue(this.fatherData[key]);
        })
      }
   }*/  

    ob["entityName"] = this.entityName;
    
    this.http.post(ob,"JsonBrokerServices/save",true).subscribe(
      data=> {
     
        if ( this.addingNewRow){
          this.addingNewRow = false;          
          //this.fetch(0,false);
          this.fr.refreshPk(this.dynamicForm,data);
          this.gotoLastRow();
        }else{
          let ob2:Object = {
            "entityName":this.entityName,
            "condition":this.trasnformToString(data),
            "showPresentation":true
          }

          
          
          this.refreshData(ob2,(data:Object)=>{
            
            this.selectedRow = [];
            this.dynamicTable.selected = [data];
            //this.selectedRow[0] = data as columnsDef;
            this.selectedRow[0] = data as columnsDef;
            this.dynamicTable.bodyComponent.select.emit();
      
          });
          
        }
        this.loadingIndicator = false;

        this.localSnackBar.showSuccess("Inserido ou Alterado com sucesso.");
      },
      error=>{
          //this.dialogService.errorDialoag = true;
          this.localSnackBar.showError(error);
          this.enableSave = true;
          this.editingRow = true;
          this.loadingIndicator = false;
          this.cd.markForCheck();
      },
      ()=>{
        this.loadingIndicator = false;
      }

    )
    
  }

  gotoFirstRow(){
    this.dynamicTable.selected = [this.rows[0]];
    this.selectedRow[0] = this.dynamicTable.selected[0]  as columnsDef;
    //this.offSetPosition.next(0);
    this.dynamicTable.bodyComponent.updateOffsetY(0);
    this.dynamicTable.bodyComponent.select.emit();
  }

  gotoBefRow(){

    let i:number = this.rows.indexOf(this.selectedRow[0]);

    this.dynamicTable.selected = [];

    if ( i - 1 < 0){
      this.dynamicTable.selected = [this.rows[i]];
      this.selectedRow[0] = this.dynamicTable.selected[0]  as columnsDef;
      this.dynamicTable.bodyComponent.select.emit();
      return;
    }else{
      this.dynamicTable.selected = [this.rows[i-1]];
      this.selectedRow[0] = this.dynamicTable.selected[0]  as columnsDef;
      const viewHeight = this.dynamicTable.bodyHeight;
      let offSet:number = this.dynamicTable.offset + 1;
      let pageSize:number = Math.floor(viewHeight / this.rowHeight);

      if ( ((pageSize * this.rowHeight )* offSet ) >= ( ( (i-1 ) * this.rowHeight )) - this.headerHeight - this.dynamicTable.summaryHeight){
        this.dynamicTable.bodyComponent.updateOffsetY((i-1)/this.dynamicTable.bodyComponent.pageSize);
        //this.offSetPosition.next((i-1)/this.dynamicTable.bodyComponent.pageSize);
      }
    
      this.dynamicTable.bodyComponent.select.emit();
    }

  }

  gotoLastRow(){

    this.fetch(0,false,false,()=>{     
          if (false == this.loadingIndicator) {
            this.dynamicTable.selected = [this.rows[this.rows.length-1]];
            this.selectedRow[0] = this.dynamicTable.selected[0]  as columnsDef;
            setTimeout(()=>{
                this.dynamicTable.bodyComponent.updateOffsetY(((this.rows.length-1)+1)/this.dynamicTable.bodyComponent.pageSize);
                //this.offSetPosition.next(((this.rows.length-1)+1)/this.dynamicTable.bodyComponent.pageSize);
            },300);
            this.dynamicTable.bodyComponent.select.emit();
          }
         } 
      );
      
  }

  gotoNextRow(){
    
    let i:number = this.rows.indexOf(this.selectedRow[0]);
    this.dynamicTable.selected = [];

    if ( i+1 >= this.rows.length){
      this.dynamicTable.selected = [this.rows[i]];
      this.selectedRow[0] = this.dynamicTable.selected[0]  as columnsDef;
      this.dynamicTable.bodyComponent.select.emit();
      return;
    }else{
      this.dynamicTable.selected = [this.rows[i+1]];
      this.selectedRow[0] = this.dynamicTable.selected[0]  as columnsDef;
      this.dynamicTable.bodyComponent.select.emit();

      const viewHeight = this.dynamicTable.bodyHeight;
      let offSet:number = this.dynamicTable.offset + 1;
      let pageSize:number = Math.floor(viewHeight / this.rowHeight);

      if ( ((pageSize * this.rowHeight )* offSet ) <= ( ( (i + 1) * this.rowHeight )) + this.headerHeight + this.dynamicTable.summaryHeight){
        this.dynamicTable.bodyComponent.updateOffsetY((i+1)/this.dynamicTable.bodyComponent.pageSize);
      }
    }
  }
  
  trasnformToString(data:Object):string{
    
    let newData:string = "";
    let i:number = 0;
    for ( let key of Object.keys(data)){
        if ( i > 0 ){
          newData = newData  +  ` and ${key} =  ${data[key]} `;
        }else{
          newData = newData  +  ` ${key} =  ${data[key]} `;
        }
        i++;
    }

    newData = newData.toLowerCase();
    return newData;
  }

  refreshData(ob:Object,func?:(ob:Object)=>void ){
    
    let r:Object = {};
    let index = this.rows.indexOf(this.selectedRow[0]);
    
   // this.loadingIndicator = true;
    this.http.post(ob,"JsonBrokerServices/find", true).subscribe(
      data=>{
          
          r = data[this.entityName.toString()][0];
          this.rows[index] = data[this.entityName.toString()][0];
          setTimeout(()=>{
            this.rows = [...this.rows];
            this.temp  = [...this.rows];
          },50);
          this.rows = [...this.rows];
          this.temp  = [...this.rows];
          if ( func != null ){
            func.call(this,r);
          }

      },
      error=>{
        this.loadingIndicator = false;
        this.cd.markForCheck();
        throw("Erro:"+JSON.parse(error._body)["message"]  );
      },
      ()=>{
        this.loadingIndicator = false;
      }
    );

  }

  
  expandFields( dynamicTable: DatatableComponent){
    
    let width:number = dynamicTable._innerWidth-20;
    let columns:number =  (dynamicTable.columns.length);
    let colSize:number = width / columns;
    //let columnsDirective:QueryList<DataTableColumnDirective> =  (dynamicTable.columnTemplates as QueryList<DataTableColumnDirective>);
    let columnsDirective:TableColumn[] = dynamicTable.columns;;

    for ( var i = 0; i < columns; i++){
      let size:EventEmitter<any> = dynamicTable.resize;
      //let dataTableColumnDirective:DataTableColumnDirective = columnsDirective.find((item:DataTableColumnDirective,index:number,array:DataTableColumnDirective[]) => {return index==i});
      let dataTableColumnDirective:TableColumn = columnsDirective.find((item:TableColumn,index:number,array:TableColumn[])=>{
        return index==i;
      });
      if ( i == columns-1  ){
        size.emit({ column: dataTableColumnDirective,newValue:width});
        }else{
          size.emit({ column: dataTableColumnDirective,newValue:colSize });
          width = width - colSize;
        }
    }

  }

  
}
